export const SCredit = 'StoreCredit'
export const GCard = 'GiftCards'
export const Loyalty = 'Loyalty'
export const LabelPrintFormat = 'LabelPrintFormat'
export const SKUGen = 'SKUGeneration'
export const UserSwitchSetting = 'UserSwitchSetting'
export const BarCodeSettings = 'BarCodeSettings'
export const SKUSeqNbr = 'SKUSeqNumber'
export const AutoAddCustomerReceipt = 'AutoAddCustomerFromReceipt'
export const GeneralPriceBook = 'GeneralPriceBook'
export const Tax = 'TaxExclusive'
export const DefaultSalesTax = 'DefaultSalesTaxID'
export const IsShowSellAttribute = 'IsShowSellAttribute'
export const IsShowSaleLayout = 'IsShowSaleLayout'
export const EnableAllPOSLayouts = 'EnableAllPOSLayouts'
export const LoyaltyAmountValue = 'LoyaltyAmountValue'
export const Printer = 'Printer'
export const TaxExclusive = 'TaxExclusive'
export const ShowSaleRefID = 'ShowSaleRefID'
export const ShowSaleTax = 'ShowSaleTax'
export const ShowSaleDate = 'ShowSaleDate'
export const ShowSaleTotalAmount = 'ShowSaleTotalAmount'
export const ShowSaleTotalTax = 'ShowSaleTotalTax'
export const ZeeReportPayments = 'ZeeReportPayments'
export const SingleScreenForCart = 'SingleScreenForCart'
export const EnableTaxCodeOnReceipt = 'EnableTaxCodeOnReceipt'
